// DS8.1 (!) comes with consts:
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
export const MODAL_FOOTER_BUTTON_SIZE = 'large';
export const MODAL_FOOTER_PRIMARY_BUTTON_MIN_WIDTH = 100;
import React, { useContext } from 'react';
import c from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ModalWrapper from '../../ModalWrapper';
import ModalLayout from '../../ModalLayout';
import ModalHeader from '../../ModalHeader';
import ModalFooter from '../../ModalFooter';
/** Our Standard modal. Has a heading, subheading, close button, and footer.  */ const Modal = (_param)=>{
    var { isOpen, heading, subheading, headerLeft, headerRight, headerClassName, preamble, footerLeft, footerRight, footer, footerClassName, showHeaderBorder, showFooterBorder, children, className, contentClassName, innerScrollRef, withScrollableContentWrapper = true, isFullscreen: isFullscreenProp, layoutClassName, ignoreClickOutside } = _param, rest = _object_without_properties(_param, [
        "isOpen",
        "heading",
        "subheading",
        "headerLeft",
        "headerRight",
        "headerClassName",
        "preamble",
        "footerLeft",
        "footerRight",
        "footer",
        "footerClassName",
        "showHeaderBorder",
        "showFooterBorder",
        "children",
        "className",
        "contentClassName",
        "innerScrollRef",
        "withScrollableContentWrapper",
        "isFullscreen",
        "layoutClassName",
        "ignoreClickOutside"
    ]);
    const isMobile = useContext(MobileContext);
    const isFullscreen = isFullscreenProp !== null && isFullscreenProp !== void 0 ? isFullscreenProp : isMobile ? true : false;
    return /*#__PURE__*/ React.createElement(ModalWrapper, _object_spread({
        isOpen: isOpen,
        className: c(className, ignoreClickOutside && 'ignore-react-onclickoutside'),
        isFullscreen: isFullscreen
    }, rest), /*#__PURE__*/ React.createElement(ModalLayout, {
        className: layoutClassName,
        isFullscreen: isFullscreen,
        withScrollableContentWrapper: withScrollableContentWrapper,
        innerScrollRef: innerScrollRef,
        header: heading && /*#__PURE__*/ React.createElement(ModalHeader, {
            className: headerClassName,
            heading: heading,
            subheading: subheading,
            left: headerLeft,
            right: headerRight
        }),
        preamble: preamble,
        content: children,
        contentClassName: contentClassName,
        footer: footer || (!!footerLeft || !!footerRight) && /*#__PURE__*/ React.createElement(ModalFooter, {
            left: footerLeft,
            right: footerRight
        }),
        footerClassName: footerClassName,
        headerBorder: showHeaderBorder,
        footerBorder: showFooterBorder
    }));
};
Modal.displayName = 'Modal';
export default Modal;
